
export const SystemUserId: number = 1;
export const AdminContactEmail: string = "ugportaladmin@amer.mhps.com";
export const PrivacyPolicy: string = "https://www.mhi.com/privacy.html ";
export const TermsOfUse: string = "https://www.mhi.com/conditions.html";
export const Confidentiality: string = "https://amermhi.com/files/MP_Insurance_Community_Confidential_and_Proprietary_Information.pdf";